<template>
    <!-- 公司简介 -->
    <div>
        <pageNav v-if="isMobile" :currentActiveNav="'公司简介'"></pageNav>
        <pageHeader></pageHeader>

        <div class="content">
            <pageNav :currentActiveNav="'公司简介'" v-if="!isMobile"></pageNav>
            <div class="company">
                <div class="company-year">
                    <div class="company-year-item" style="">
                        <div class="company-year-top">{{ config.companyYear.descTop }}</div>
                        <!-- 数字滚动 19 -->
                        <NumberScroll config.companyYear.year
                            :targetNumber="config.companyYear.year + config.companyYear.yearName + config.companyYear.yearString"
                            :speed="7">
                        </NumberScroll>
                        <div class="company-year-top">{{ config.companyYear.descBottom }}</div>
                    </div>
                    <div class="company-year-item">
                        <div class="company-year-top">{{ config.companyYear2.descTop }}</div>
                        <!-- 数字滚动 5-->
                        <NumberScroll config.companyYear2.year
                            :targetNumber="config.companyYear2.year + config.companyYear2.yearName" :speed="5">
                        </NumberScroll>
                        <div class="company-year-top">{{ config.companyYear2.descBottom }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="company-img">
            <img :src="config.workSrc" alt="" />
        </div>
        <div class="company-desc">
            <div class="company-desc-item" v-for="(descItem, index) in config.descList" :key="index">
                <div class="company-desc-title">{{ descItem.title }}</div>
                <div class="company-desc-content">
                    <div class="company-desc-left">{{ descItem.desc }}</div>
                    <div class="company-desc-right">
                        {{ descItem.descMore }}
                    </div>
                </div>
            </div>
        </div>
        <div class="footer">
            <div>
                <div>
                    {{ config.footer.title1 }}
                    <span style="font-weight: 600;">
                        {{ config.footer.title2 }}
                    </span>
                    {{ config.footer.title3 }}
                </div>
                <div style="text-align: right;margin-top:45px ;font-size: 32px;">
                    {{ config.footer.info }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { config } from "./js/company";
import pageHeader from "./components/header.vue";
import pageNav from "./components/navMenu.vue";
import NumberScroll from './components/NumberScroll.vue'
export default {
    name: "",
    components: { pageHeader, pageNav, NumberScroll },
    data() {
        return {
            config: config,
            year: config.companyYear.year,
            level: config.companyYear2.year,
            hasShow: false, // 是否已展示过动画
        };
    },
    watch: {},
    computed: {

        isMobile() {
            return this.$store.getters.isMobile;
        }
    },
    methods: {
    },
};
</script>

<style scoped lang="less">
.content {
    background: @mainBgColor;
    padding: 45px 68px 240px;

    .footer {
        background-color: #FFF100;
        height: 366px;
        font-size: 40px;
        color: #000000;
    }
}

.company-img {
    text-align: center;
    margin-top: -330px;
    padding: 0 68px;

    img {
        width: 100%;
    }
}

.company-desc {
    padding: 120px 68px 150px;

    .company-desc-item {
        .company-desc-title {
            font-size: 40px;
            margin-bottom: 40px;
        }

        .company-desc-content {
            display: grid;
            grid-template-columns: 1fr 1fr;
            grid-column-gap: 20px;

            .company-desc-left {
                font-size: 24px;
            }

            .company-desc-right {
                font-size: 20px;
            }
        }
    }
}

.company-year {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 20px;
    padding: 0 68px 150px;
    color: @mainTextColor ;

    .company-year-item {
        padding: 51px 0;
        border-top: 1px solid @mainGrayColor3;
        border-bottom: 1px solid @mainGrayColor3;

        .company-year-top {
            font-size: 20px;
        }





        .company-year-year2 {
            margin-left: -50px;
        }


    }



}

.footer {
    background-color: #FFF100;
    font-size: 40px;
    color: #000000;
    height: 366px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

@media @mobile {
    .content {
        padding: 20px 16px 80px;
    }

    .company-year {
        grid-template-columns: 1fr;
        grid-column-gap: 0;
        grid-row-gap: 20px;
        padding: 0 16px 60px;

        .company-year-item {
            // padding: 20px 0;
            // border-bottom: none;
            border: none;

            .company-year-top {
                font-size: 16px;
                // line-height: 1.4;
            }



            .company-year-year2 {
                margin-left: -24px;
            }


        }

        .company-year-item:first-child {
            border-bottom: 1px solid @mainGrayColor3;
        }
    }

    .company-img {
        margin-top: -120px;
        padding: 0 16px;

        img {
            width: 100%;
            height: auto;
        }
    }

    .company-desc {
        padding: 0 16px 30px 16px;

        .company-desc-item {
            margin-top: 30px;

            .company-desc-title {
                font-size: 20px;
                margin-bottom: 20px;
                line-height: 1.3;
            }

            .company-desc-content {
                grid-template-columns: 1fr;
                grid-column-gap: 0;
                grid-row-gap: 16px;

                .company-desc-left {
                    font-size: 17px;
                    line-height: 1.5;
                }

                .company-desc-right {
                    font-size: 12px;
                    line-height: 1.5;
                    color: #6E6D6F;
                }
            }
        }
    }

    .footer {
        height: auto;
        padding: 40px 16px;
        font-size: 24px;
        line-height: 1.4;

        >div>div:last-child {
            text-align: left;
            margin-top: 20px;
            font-size: 20px;
        }
    }
}
</style>